export enum TenaEpiRules {
    WaistAndHipsize = 'Hide waist and hipsize',
    PackInfo = 'Hide Pack Information',
    VarientInfo = 'Hide Variant Information'
}
